// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"89":"68128390","154":"f71f39da","172":"756a9c80","319":"c946ab66"}[chunkId] + ".css";
};